/**
 * Conditional Node Component
 */
import React, { memo } from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { GitBranch } from 'lucide-react';
import styles from './Nodes.module.css';

export const ConditionalNode: React.FC<NodeProps> = memo(({ data, selected }) => {
  return (
    <div className={`${styles.node} ${styles.conditionalNode} ${selected ? styles.selected : ''}`}>
      <Handle
        type="target"
        position={Position.Left}
        className={styles.handle}
      />
      <div className={styles.nodeContent}>
        <div className={styles.nodeIcon} style={{ backgroundColor: '#f59e0b' }}>
          <GitBranch size={16} color="white" />
        </div>
        <div className={styles.nodeDetails}>
          <span className={styles.nodeLabel}>{data.label || 'Conditional'}</span>
          {data.condition && (
            <span className={styles.nodeSubtitle}>{data.condition}</span>
          )}
        </div>
      </div>
      <Handle
        type="source"
        position={Position.Right}
        id="true"
        style={{ top: '30%' }}
        className={styles.handle}
      />
      <Handle
        type="source"
        position={Position.Right}
        id="false"
        style={{ top: '70%' }}
        className={styles.handle}
      />
      <div className={styles.branchLabels}>
        <span className={styles.branchTrue}>True</span>
        <span className={styles.branchFalse}>False</span>
      </div>
    </div>
  );
});

ConditionalNode.displayName = 'ConditionalNode';
